import React, { useState } from "react";

const DeleteConfirmationModal = ({
	open,
	title,
	message,
	onConfirm,
	onCancel,
	requireConfirmationText = null,
	isBoQLinked = false,
	itemType = "Task", // "Task" or "Task Group"
	itemName = "",
}) => {
	const [confirmationInput, setConfirmationInput] = useState("");

	if (!open) return null;

	const isConfirmationMatched =
		!requireConfirmationText || confirmationInput === requireConfirmationText;
	const isDeleteDisabled = requireConfirmationText && !isConfirmationMatched;

	const handleReset = () => {
		setConfirmationInput("");
		onCancel();
	};

	return (
		<div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50">
			<div
				className="bg-white rounded-lg shadow-lg p-6 w-[520px] max-w-[90%]"
				onClick={(e) => e.stopPropagation()}
			>
				<h3 className="text-2xl font-semibold text-purple-900 mb-4">{title}</h3>

				{/* Message with conditional BoQ content */}
				<div className="mb-4">
					<p className="text-sm text-gray-600 whitespace-pre-line">{message}</p>

					{/* Confirmation Input for BoQ-linked items */}
					{isBoQLinked && requireConfirmationText && (
						<div className="mt-4 pt-4 border-t">
							<label className="block text-sm font-medium text-gray-700 mb-2">
								Type {itemType === "Task Group" ? "BoQ Section" : "BoQ Item"} name to
								confirm:
							</label>
							<input
								type="text"
								value={confirmationInput}
								onChange={(e) => setConfirmationInput(e.target.value)}
								placeholder={`Type "${requireConfirmationText}" to confirm`}
								className={`w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 ${
									confirmationInput === requireConfirmationText
										? "border-green-500 focus:ring-green-500"
										: "border-gray-300 focus:ring-purple-500"
								}`}
								autoFocus
							/>
							{confirmationInput === requireConfirmationText && (
								<p className="text-xs text-green-600 mt-1">✓ Ready to delete</p>
							)}
						</div>
					)}
				</div>

				{/* Action buttons */}
				<div className="flex justify-end gap-3">
					<button
						onClick={handleReset}
						className="px-4 py-2 rounded border text-gray-700 bg-white hover:bg-gray-50"
					>
						Cancel
					</button>
					<button
						onClick={onConfirm}
						disabled={isDeleteDisabled}
						className={`px-4 py-2 rounded text-white ${
							isDeleteDisabled
								? "bg-red-300 cursor-not-allowed"
								: "bg-red-500 hover:bg-red-600"
						}`}
					>
						Delete
					</button>
				</div>
			</div>
		</div>
	);
};

export default DeleteConfirmationModal;


